import { Context, useContext } from 'react';
import * as React from 'react';

export type SelectedLanguageContextProps = {
  language: string | undefined;
  setLanguage: (value: string | undefined) => void;
};

export const defaultSelectedLanguageContextProps: SelectedLanguageContextProps =
  {
    language: undefined,
    setLanguage: () => {},
  };

export const SelectedLanguageContext: Context<SelectedLanguageContextProps> =
  React.createContext(defaultSelectedLanguageContextProps);

export const useSelectedLanguageContext = (): SelectedLanguageContextProps => {
  return useContext<SelectedLanguageContextProps>(SelectedLanguageContext);
};
